(function () {
  const TEMPLATE_ID = '5419b6a8b0d04a076446a9ad';
  const DEFAULT_UNIT = '5b8775ccdd36a800011d73d0';

  function starFill(rating, index) {
    const filled = Number(rating) - (index - 1);
    if (filled >= 1) return 100;
    if (filled <= 0) return 0;
    return Math.round(filled * 100);
  }

  function paintStars(root, rating) {
    const stars = root.querySelectorAll('[data-trust-star]');
    stars.forEach((star, i) => {
      star.style.setProperty('--trust-fill', `${starFill(rating, i + 1)}%`);
    });
  }

  function formatCount(count) {
    const n = Number(count);
    if (!Number.isFinite(n)) return String(count);
    return n.toLocaleString('en-AU');
  }

  function apply(root, rating, reviews) {
    const score = Number(rating);
    if (!Number.isFinite(score)) return false;

    paintStars(root, score);

    const ratingEl = root.querySelector('[data-trust-rating]');
    const countEl = root.querySelector('[data-trust-count]');
    const copy = root.querySelector('[data-trust-copy]');
    if (ratingEl) ratingEl.textContent = score.toFixed(1);
    if (countEl && reviews != null) countEl.textContent = formatCount(reviews);
    if (copy instanceof HTMLElement) copy.hidden = false;

    const label = root.dataset.trustLabelTemplate;
    if (label) {
      root.setAttribute(
        'aria-label',
        label.replace('__RATING__', score.toFixed(1)).replace('__COUNT__', formatCount(reviews ?? ''))
      );
    }
    return true;
  }

  async function hydrate(root) {
    const unitId = root.dataset.businessunitId || DEFAULT_UNIT;
    if (!unitId) return;

    try {
      const url = `https://widget.trustpilot.com/trustbox-data/${TEMPLATE_ID}?businessUnitId=${encodeURIComponent(unitId)}&locale=en-GB`;
      const res = await fetch(url, { mode: 'cors' });
      if (!res.ok) return;

      const data = await res.json();
      const unit = data.businessUnit || data;
      const rating = unit.trustScore ?? unit.stars;
      const reviews = unit.numberOfReviews && unit.numberOfReviews.total;
      if (rating != null) apply(root, rating, reviews);
    } catch {
      /* Ad-blocked widget: leave numbers hidden rather than showing schema defaults. */
    }
  }

  function init() {
    document.querySelectorAll('[data-trustpilot-rating]').forEach(hydrate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
